import Vue from "vue";
import { VuePlugin } from "vuera";

Vue.use(VuePlugin);
